import React, { useState, useEffect } from 'react'
import { BiEdit } from 'react-icons/bi';
import { MdContentCopy, MdDeleteForever } from 'react-icons/md';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { IoSearch } from 'react-icons/io5';
import { formatDate } from '../Common/Common';
import { RxDotsHorizontal } from "react-icons/rx";
import * as XLSX from 'xlsx';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { handleDuplicateDeal, ImportDealFile } from '../../Redux/DealSlice';
import moment from 'moment';
import { FormatDateMoment } from '../Common/defaultValue';
import Pagination from '../Common/Pagination';

const DealListView = ({ setCurrentPage, rowsPerPage, setrowsPerPage, loading, setSearchTerm, currentPage, searchTerm, handlePageChange, handleDeleteDeal, selectedDealIds, selectAll, handleSelectAll, store, totalPages, sidebarOpen, handleSort, currentRows, handleCheckboxChange, setShowModal, Editdeal, setloadFrist }) => {
    const dispatch = useDispatch()
    const [AciteOption, setAciteOption] = useState(false);
    const navigate = useNavigate()
    const [openActionMenuId, setOpenActionMenuId] = useState(null);

    useEffect(() => {
        const handleOutsideClick = () => setOpenActionMenuId(null);
        document.addEventListener("click", handleOutsideClick);
        return () => document.removeEventListener("click", handleOutsideClick);
    }, []);

    const handleExport = () => {
        const data = store.getDeals.map(deal => ({
            Title: deal.title,
            LabelName: deal.labelName,
            PipelineStage: deal.pipelineStage,
            Value: deal.value,
            OrganizationName: deal.organizationName,
            ContactPerson: deal.personName,
            CurrencyName: deal.currencyName,
            VisibleToName: deal.visibleName,
            SourceChannel: deal.sourceChannel,
            ExpectedClosedDate: deal.expectedCloseDate,
            PeopleName: deal?.personName,
            ProjectName: ''
        }));

        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Deals");
        XLSX.writeFile(workbook, "dealsdata.xlsx");
        setAciteOption(!AciteOption)
    };

    const DuplicateDeal = async (id) => {
        await dispatch(handleDuplicateDeal(id)).then((res) => {
            setloadFrist(true)
        }).catch((error) => console.log('error >> ', error))
    }

    const uploadExcel = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append('ExcelFilePath', file);
        try {
            dispatch(ImportDealFile(formData)).then((res) => {
                setAciteOption(!AciteOption)
            })
        } catch (error) {
            console.error('Upload error:', error);
        }
    };

    return (
        <div
            className="bg-gray-50 rounded-lg dark:bg-gray-800"
            id="list"
            role="tabpanel"
            aria-labelledby="list-tab"
        >
            {!loading && (
                <>
                    <div className="flex items-center justify-end px-4 py-3 border-b border-slate-100 gap-3">
                        <div className="crm-search-box">
                            <IoSearch size={14} />
                            <input
                                type="text"
                                placeholder="Search deals..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                        {selectedDealIds && selectedDealIds.length > 0 && (
                            <button
                                className="p-2 rounded-lg text-red-500 hover:bg-red-50 transition-colors"
                                onClick={() => handleDeleteDeal()}
                                title="Delete Selected"
                            >
                                <MdDeleteForever size={18} />
                            </button>
                        )}
                        <div className="relative">
                            <button
                                type="button"
                                className="p-2 hover:bg-slate-50 border border-slate-200 rounded-lg text-slate-500 hover:text-slate-800 transition-colors"
                                onClick={() => setAciteOption(!AciteOption)}
                            >
                                <RxDotsHorizontal size={16} />
                            </button>
                            {AciteOption && (
                                <div className="absolute right-0 mt-1 w-44 bg-white border border-slate-100 rounded-lg shadow-lg py-1 z-50 text-left">
                                    {currentRows.length > 0 && (
                                        <button
                                            onClick={handleExport}
                                            className="w-full text-left px-4 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors"
                                        >
                                            Export file results
                                        </button>
                                    )}
                                    <label className="w-full text-left px-4 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors cursor-pointer block">
                                        <input
                                            type="file"
                                            className="hidden"
                                            onChange={uploadExcel}
                                            accept=".xls,.xlsx"
                                        />
                                        Import Data
                                    </label>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="relative scroll-inner">
                        <table className="crm-table">
                            <thead>
                                <tr>
                                    <th scope="col" className="w-4 p-4 text-center">
                                        <label className="custom-label">
                                            <div className="bg-white dark:bg-slate-600/40 border border-slate-300 dark:border-slate-600 rounded w-4 h-4  inline-block leading-4 text-center -mb-[3px]">
                                                <input
                                                    type="checkbox"
                                                    checked={selectAll}
                                                    onChange={() => handleSelectAll()}
                                                />
                                            </div>
                                        </label>
                                    </th>
                                    <th scope="col" className="mw-200 p-4">
                                        <div className="flex items-center w-full">
                                            Title
                                            <svg
                                                className="w-3 h-3 ms-1.5 cursor-pointer"
                                                aria-hidden="true"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="currentColor"
                                                viewBox="0 0 24 24"
                                                onClick={() => handleSort("title")}
                                            >
                                                <path
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Zm-6.852 0 3.426 5.05-3.426-5.05Z"
                                                />
                                            </svg>
                                        </div>
                                    </th>
                                    <th scope="col" className="mw-200 p-4 text-center">
                                        Label
                                    </th>
                                    <th scope="col" className="mw-200 p-4 text-center">
                                        Pipeline Stage
                                    </th>
                                    <th scope="col" className="mw-200 p-4 text-center">
                                        Value
                                    </th>
                                    <th scope="col" className="mw-200 p-4 text-center">
                                        Weighted value
                                    </th>
                                    <th scope="col" className="mw-200 p-4 text-center">
                                        Next activity date
                                    </th>
                                    {/* <th scope="col" className="mw-200 p-4 text-center">
                                        Organization
                                    </th>
                                    <th scope="col" className="mw-200 p-4 text-center">
                                        Contact Person
                                    </th>
                                    <th scope="col" className="mw-200 p-4 text-center">
                                        Currency
                                    </th>
                                    <th scope="col" className="mw-200 p-4 text-center">
                                        Visible
                                    </th>
                                    <th scope="col" className="mw-200 p-4 text-center">
                                        Deal created
                                    </th>
                                    <th scope="col" className="mw-200 p-4 text-center">
                                        Update time
                                    </th>
                                    <th scope="col" className="mw-200 p-4 text-center">
                                        Expected Close Date
                                    </th>
                                    <th scope="col" className="mw-200 p-4 text-center">
                                        Status
                                    </th>
                                    <th scope="col" className="mw-200 p-4 text-center">
                                        Source
                                    </th>
                                    <th scope="col" className="mw-200 p-4 text-center">
                                        Source Channel ID
                                    </th>
                                    <th scope="col" className="mw-200 p-4 text-center">
                                        Source Channel
                                    </th>
                                    <th scope="col" className="mw-200 p-4 text-center">
                                        Lost time
                                    </th>
                                    <th scope="col" className="mw-200 p-4 text-center">
                                        Lost reason
                                    </th>
                                    <th scope="col" className="mw-200 p-4 text-center">
                                        Product quantity
                                    </th>
                                    <th scope="col" className="mw-200 p-4 text-center">
                                        Product name
                                    </th>
                                    <th scope="col" className="mw-200 p-4 text-center">
                                        Product amount
                                    </th>
                                    <th scope="col" className="mw-200 p-4 text-center">
                                        Product ACV
                                    </th>
                                    <th scope="col" className="mw-200 p-4 text-center">
                                        Product ARR
                                    </th>
                                    <th scope="col" className="mw-200 p-4 text-center">
                                        Product MRR
                                    </th>
                                    <th scope="col" className="mw-200 p-4 text-center">
                                        Owner
                                    </th>
                                    <th scope="col" className="mw-200 p-4 text-center">Done activities</th>
                                    <th scope="col" className="mw-200 p-4 text-center">Activities to do</th>
                                    <th scope="col" className="mw-200 p-4 text-center">Total activities</th> */}
                                    <th scope="col" className="mw-200 p-4 text-center">
                                        Action
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentRows?.length > 0 ? (
                                    currentRows.map((item, index, arr) => {
                                        const showUpward = index >= arr.length - 2 && arr.length > 1;
                                        return (
                                        <tr
                                            key={index}
                                            className="hover:bg-slate-50 transition-colors border-b border-slate-100"
                                        >
                                            <td className="w-4 p-4 text-center">
                                                <label className="custom-label">
                                                    <div className={`bg-white dark:bg-slate-600/40 border border-slate-200 dark:border-slate-600 rounded w-4 h-4  inline-block leading-4 text-center -mb-[3px]`}>
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedDealIds.includes(
                                                                item?.dealID
                                                            )}
                                                            onChange={() => handleCheckboxChange(item.dealID)}
                                                        />
                                                    </div>
                                                </label>
                                            </td>
                                            <td
                                                className={`max-w-8 truncate p-3 text-sm text-left cursor-pointer capitalize font-semibold ${item?.isWon === 1 ? "text-green-600" : item?.isWon === 0 ? "text-red-500" : "text-slate-700"}`}
                                                onClick={() => navigate(`/deal/${item?.dealID}`)}
                                            >
                                                {item?.title}
                                            </td>
                                            <td className="mw-200 p-3 text-sm text-center whitespace-nowrap">
                                                <span
                                                    className="text-xs font-semibold px-2 py-0.5 rounded-full"
                                                    style={{ backgroundColor: item?.color + '20', color: item?.color }}
                                                >
                                                    {item?.labelName}
                                                </span>
                                            </td>
                                            <td className="mw-200 p-3 text-sm text-slate-500 text-center whitespace-nowrap capitalize">
                                                {item?.pipelineStage}
                                            </td>
                                            <td className="mw-200 p-3 text-sm text-slate-600 text-center whitespace-nowrap font-medium">
                                                {item?.currencyCode !== null ? item?.currencyCode : ''} {item?.value?.toLocaleString('en-IN')}
                                            </td>
                                            <td className="mw-200 p-3 text-sm text-slate-500 text-center whitespace-nowrap">
                                                {item?.currencyCode !== null ? item?.currencyCode : ''} {item?.value?.toLocaleString('en-IN')}
                                            </td>
                                            <td className="mw-200 p-3 text-sm text-slate-500 text-center whitespace-nowrap">
                                                {item?.nextActivityDate ? FormatDateMoment(item?.nextActivityDate) : ''}
                                            </td>
                                            {/* <td
                                                className="mw-200 p-3 text-sm text-indigo-600 hover:text-indigo-800 text-center whitespace-nowrap cursor-pointer capitalize"
                                                onClick={() => navigate(`/detailsOrganization/${item?.organizationID}`)}
                                            >
                                                {item?.organizationName}
                                            </td>
                                            <td
                                                className="mw-200 p-3 text-sm text-indigo-600 hover:text-indigo-800 text-center whitespace-nowrap cursor-pointer capitalize"
                                                onClick={() => navigate(`/detailsPeople/${item?.peopleID}`)}
                                            >
                                                {item?.personName}
                                            </td>
                                            <td className="mw-200 p-3 text-sm text-slate-500 text-center whitespace-nowrap capitalize">
                                                {item?.currencyName}
                                            </td>
                                            <td className="mw-200 p-3 text-sm text-slate-500 text-center whitespace-nowrap capitalize">
                                                {item?.visibleName}
                                            </td>
                                            <td className="mw-200 p-3 text-sm text-slate-500 text-center whitespace-nowrap">
                                                {formatDate(item?.createdDate)}
                                            </td>
                                            <td className="mw-200 p-3 text-sm text-slate-500 text-center whitespace-nowrap">
                                                {item?.updatedDate ? moment(item?.updatedDate).format('lll') : ''}
                                            </td>
                                            <td className="mw-200 p-3 text-sm text-slate-500 text-center whitespace-nowrap">
                                                {formatDate(item?.expectedCloseDate)}
                                            </td>
                                            <td className="mw-200 p-3 text-sm text-center whitespace-nowrap">
                                                <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${item?.isWon === 1 ? 'bg-green-50 text-green-700' : item?.isWon === 0 ? 'bg-red-50 text-red-700' : 'bg-blue-50 text-blue-700'}`}>
                                                    {item?.isWon === 1 ? "Won" : item?.isWon === 0 ? "Lost" : "Open"}
                                                </span>
                                            </td>
                                            <td className="mw-200 p-3 text-sm text-slate-500 text-center whitespace-nowrap capitalize">
                                                {item?.sourceType}
                                            </td>
                                            <td className="mw-200 p-3 text-sm text-slate-500 text-center whitespace-nowrap">
                                                {item?.sourceChannelID}
                                            </td>
                                            <td className="mw-200 p-3 text-sm text-slate-500 text-center whitespace-nowrap capitalize">
                                                {item?.sourceChannel}
                                            </td>
                                            <td className="mw-200 p-3 text-sm text-slate-500 text-center whitespace-nowrap">
                                                {item?.dealLostDateTime ? moment(item?.dealLostDateTime).format('lll') : ''}
                                            </td>
                                            <td className="max-w-60 truncate p-3 text-sm text-slate-500 text-center whitespace-nowrap capitalize">
                                                {item?.lostReason}
                                            </td>
                                            <td className="mw-200 p-3 text-sm text-slate-500 text-center whitespace-nowrap">
                                                {item?.dealProductList?.totalProducts}
                                            </td>
                                            <td className="mw-200 p-3 text-sm text-slate-500 text-center whitespace-nowrap capitalize">
                                                {item?.dealProductList && item?.dealProductList?.dealProductAmount.map((x, idx) => (<p key={idx}>{x?.productName}</p>))}
                                            </td>
                                            <td className="mw-200 p-3 text-sm text-slate-500 text-center whitespace-nowrap">
                                                ₹ {item?.dealProductList?.subTotalExcludingTax ? item?.dealProductList?.subTotalExcludingTax.toLocaleString('en-PK') : 0}
                                            </td>
                                            <td className="mw-200 p-3 text-sm text-slate-500 text-center whitespace-nowrap">
                                                {item?.dealProductList?.acv}
                                            </td>
                                            <td className="mw-200 p-3 text-sm text-slate-500 text-center whitespace-nowrap">
                                                {item?.dealProductList?.arr}
                                            </td>
                                            <td className="mw-200 p-3 text-sm text-slate-500 text-center whitespace-nowrap">
                                                {item?.dealProductList?.mrr}
                                            </td>
                                            <td className="mw-200 p-3 text-sm text-slate-500 text-center whitespace-nowrap capitalize">
                                                {item?.ownerID}
                                            </td>
                                            <td className="mw-200 p-3 text-sm text-slate-500 text-center whitespace-nowrap">{item?.doneActivity}</td>
                                            <td className="mw-200 p-3 text-sm text-slate-500 text-center whitespace-nowrap">{item?.activitiesToDo}</td>
                                            <td className="mw-200 p-3 text-sm text-slate-500 text-center whitespace-nowrap">{item?.totalActivities}</td> */}

                                            <td className="p-3 text-center whitespace-nowrap">
                                                 <div className="relative inline-block text-left">
                                                     <button
                                                         onClick={(e) => {
                                                             e.stopPropagation();
                                                             setOpenActionMenuId(openActionMenuId === item.dealID ? null : item.dealID);
                                                         }}
                                                         className="p-1.5 text-slate-500 hover:text-slate-800 hover:bg-slate-100 rounded-lg transition-colors"
                                                     >
                                                         <BsThreeDotsVertical size={16} />
                                                     </button>
                                                      {openActionMenuId === item.dealID && (
                                                           <div className={`absolute right-0 w-36 bg-white border border-slate-100 rounded-lg shadow-lg py-1 z-50 animate-in fade-in duration-100 flex flex-col ${showUpward ? 'bottom-full mb-1 slide-in-from-bottom-1' : 'top-full mt-1 slide-in-from-top-1'}`}>
                                                              <button
                                                                  onClick={(e) => {
                                                                      e.stopPropagation();
                                                                      setShowModal(true);
                                                                      Editdeal(item?.dealID);
                                                                      setOpenActionMenuId(null);
                                                                  }}
                                                                  className="w-full flex items-center gap-2 px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors text-left"
                                                              >
                                                                  <BiEdit size={14} className="text-indigo-500" />
                                                                  <span>Edit</span>
                                                              </button>
                                                              <button
                                                                  onClick={(e) => {
                                                                      e.stopPropagation();
                                                                      DuplicateDeal(item?.dealID);
                                                                      setOpenActionMenuId(null);
                                                                  }}
                                                                  className="w-full flex items-center gap-2 px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors text-left"
                                                              >
                                                                  <MdContentCopy size={14} className="text-indigo-500" />
                                                                  <span>Copy</span>
                                                              </button>
                                                          </div>
                                                      )}
                                                 </div>
                                             </td>
                                        </tr>
                                     ); })

                                ) : (
                                    <td colSpan={6}>
                                        <p className="text-center p-2">Not Found.</p>
                                    </td>
                                )}
                            </tbody>
                        </table>
                    </div>
                </>
            )}
            <Pagination name='Deals' handlePageChange={handlePageChange} currentPage={currentPage} sidebarOpen={sidebarOpen} totalPages={totalPages} length={store?.getDeals.length} setrowsPerPage={setrowsPerPage} rowsPerPage={rowsPerPage} setCurrentPage={setCurrentPage} />

        </div >
    )
}

export default DealListView
